import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const grantPermission = async (permData) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation grantPermission($caseTypeId: Int!, $teamId: Int!, $resource: String!){
        grantPermission(caseTypeId: $caseTypeId, teamId: $teamId, resource: $resource) { id permissionFlag resourceId teamId message error lowLevelErrorMessage}
      }`),
      variables: { caseTypeId: permData.caseTypeId, teamId: permData.teamId, resource: permData.resource }
    }
  )
  return response.data.grantPermission
}

export const revokePermission = async (permData) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation revokePermission($caseTypeId: Int!, $teamId: Int!, $resource: String!){
        revokePermission(caseTypeId: $caseTypeId, teamId: $teamId, resource: $resource) { message error lowLevelErrorMessage}
      }`),
      variables: { caseTypeId: permData.caseTypeId, teamId: permData.team.id, resource: permData.resource.name }
    }
  )
  return response.data.revokePermission
}

export const grantFieldsetPermission = async (permData) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation grantFieldsetPermission($caseTypeId: Int!, $teamId: Int!, $fieldSet: String!, $readOrWrite: ReadWriteEnum!){
        grantFieldsetPermission(caseTypeId: $caseTypeId, teamId: $teamId, fieldSet: $fieldSet, readOrWrite: $readOrWrite) { id permissionFlag message error lowLevelErrorMessage}
      }`),
      variables: { caseTypeId: permData.caseTypeId, teamId: permData.teamId, fieldSet: permData.fieldset.name, readOrWrite: permData.readOrWrite }
    }
  )
  return response.data.grantFieldsetPermission
}

export const revokeFieldsetPermission = async (permData) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation revokeFieldsetPermission($caseTypeId: Int!, $teamId: Int!, $fieldSet: String!){
        revokeFieldsetPermission(caseTypeId: $caseTypeId, teamId: $teamId, fieldSet: $fieldSet) { message error lowLevelErrorMessage}
      }`),
      variables: { caseTypeId: permData.caseTypeId, teamId: permData.teamId, fieldSet: permData.fieldset.name }
    }
  )
  return response.data.revokeFieldsetPermission
}

export const grantTasklistPermission = async (permData) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation grantTasklistPermission($caseTypeId: Int!, $teamId: Int!, $tasklistTemplateId: Int!, $readOrWrite: ReadWriteEnum!){
        grantTasklistPermission(caseTypeId: $caseTypeId, teamId: $teamId, tasklistTemplateId: $tasklistTemplateId, readOrWrite: $readOrWrite) { id permissionFlag message error lowLevelErrorMessage}
      }`),
      variables: { caseTypeId: permData.caseTypeId, teamId: permData.teamId, tasklistTemplateId: permData.tasklistId, readOrWrite: permData.readOrWrite }
    }
  )
  return response.data.grantTasklistPermission
}

export const revokeTasklistPermission = async (permData) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation revokeTasklistPermission($caseTypeId: Int!, $teamId: Int!, $tasklistTemplateId: Int!){
        revokeTasklistPermission(caseTypeId: $caseTypeId, teamId: $teamId, tasklistTemplateId: $tasklistTemplateId) { message error lowLevelErrorMessage }
      }`),
      variables: { caseTypeId: permData.caseTypeId, teamId: permData.teamId, tasklistTemplateId: permData.tasklistId }
    }
  )
  return response.data.revokeTasklistPermission
}
